import { StepPackage } from '@samelogic/steps';
import { RemotePackageRepository } from './RemotePackageRepository';

/**
 * PackageMemoryCache is used for setting up a cache of StepPackages
 * that will be used throughout the whole lifetime of the engine.
 *
 * The goal is to initialize the cache and pass this cache into anything that
 * requires the retrieval of the package.
 */
export class PackageMemoryCache {
  private cacheMap = new Map<string, StepPackage>();
  constructor(private readonly packageRepository: RemotePackageRepository) {}

  public async initialize(urls: string[]): Promise<void> {
    for (const url of urls) {
      const stepPackage = await this.packageRepository.getPackageByUrl(url);
      this.cacheMap.set(url, stepPackage);
    }
  }

  public async get(url: string): Promise<StepPackage> {
    let stepPackage = this.cacheMap.get(url);
    if (!stepPackage) {
      stepPackage = await this.packageRepository.getPackageByUrl(url);
    }
    return stepPackage;
  }
}
